enum PlaylistTypes {
  Regular = 0,
  Story = 1
}

export default PlaylistTypes;
